export default function (state) {
  state.isLoading = true;
  state.isLoaded = false;
}
